import { render, staticRenderFns } from "./NoteTaking.vue?vue&type=template&id=28d1e4ed&scoped=true&"
import script from "./NoteTaking.vue?vue&type=script&lang=js&"
export * from "./NoteTaking.vue?vue&type=script&lang=js&"
import style0 from "./NoteTaking.vue?vue&type=style&index=0&id=28d1e4ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1e4ed",
  null
  
)

export default component.exports